/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-footer/ag-grid-evrideo-footer.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
  align-self: stretch;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
:host span {
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
:host .page-size {
  display: flex;
  align-items: center;
  gap: 10px;
}
:host .page-size span {
  color: rgba(0, 0, 0, 0.54);
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select {
  height: 24px !important;
  width: 45px !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-text-field {
  padding: 0 !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-select-value {
  width: fit-content !important;
  margin-right: 5px;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-infix {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-line-ripple::after,
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mdc-line-ripple::before {
  border-bottom: none !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host .page-size ::ng-deep .mat-mdc-form-field-type-mat-select .mat-mdc-select-arrow-wrapper {
  transform: none !important;
}
:host .pages-view {
  display: flex;
}
:host .pages-view span {
  margin-right: 6px;
}
:host .pages-view button {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  height: 20px;
  width: 20px;
  overflow: hidden;
  text-indent: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  opacity: 0.54;
  padding: 0;
  position: relative;
  top: 2px;
}
:host .pages-view button[ref=bf] {
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDRMOCA4bDQgNE00LjUgNHY4IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button[ref=bp] {
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkgNEw1IDhsNCA0IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button[ref=bn] {
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYgMTJsNC00LTQtNCIgc3Ryb2tlPSIjN0Y4QzhEIiBmaWxsPSJub25lIi8+PC9zdmc+);
}
:host .pages-view button[ref=bl] {
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQgMTJsNC00LTQtNG03LjUgMHY4IiBzdHJva2U9IiM3RjhDOEQiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
}
:host .pages-view button:hover {
  opacity: 0.87;
}
/*# sourceMappingURL=ag-grid-evrideo-footer.component.css.map */
